/* eslint-disable @next/next/no-img-element */
import { SRLWrapper } from 'simple-react-lightbox';
import classNames from 'classnames';
import { ContentDataBlockImage } from '@amf/shared/components/content/Content';
import useImageColor from '@amf/shared/hooks/useImageColor';
import { stringifyHtml } from '@amf/shared/utils/string';

const SRLOptions: Record<string, any> = {
  lightboxTransitionSpeed: 0.15,
  buttons: {
    showAutoplayButton: false,
    showDownloadButton: false,
    showThumbnailsButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    iconPadding: '8px',
    size: '40px',
  },
  thumbnails: {
    showThumbnails: false,
  },
};

interface ImageProps {
  block: ContentDataBlockImage;
}

export default function Image({ block }: ImageProps) {
  const { r, g, b } = useImageColor(block.data.file.url);
  const caption = stringifyHtml(block.data.caption);
  return (
    <SRLWrapper
      options={{
        ...SRLOptions,
        caption: {
          showCaption: caption.length > 0,
          captionTextTransform: 'uppercase',
        },
      }}
    >
      <div
        style={{ backgroundColor: `rgb(${r}, ${g}, ${b})` }}
        className={classNames('Content__image', {
          'Content__image--withBorder': block.data.withBorder,
          'Content__image--withBackground': block.data.withBackground,
          'Content__image--small': !block.data.stretched,
        })}
      >
        <img src={block.data.file.url} alt={caption} />
        {caption.length > 0 && <span className='Content__imageCaption'>{caption}</span>}
      </div>
    </SRLWrapper>
  );
}
